angular.module('tgaApp').controller('InterstitialController', [
  '$scope',
  '$rootScope',
  '$filter',
  '$timeout',
  function ($scope, $rootScope, $filter, $timeout) {
    $scope.questionVariables = {
      questionAnswered: false,
      questionCorrect: false,
      timedOut: false,
    };

    $scope.videoSrc = '';
    $scope.videoPlayer = undefined;
    $scope.canContinue = true;
    $scope.resetTrack = false;
    $scope.onVideoEnd = function () {
      $scope.resetTrack = true;
      $timeout(($scope.canContinue = true));
    };

    $scope.youtubePlayerSetup = function (iframe) {
      function onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.ENDED) {
          $scope.onVideoEnd();
        }
      }
      $scope.videoPlayer = new YT.Player(iframe, {
        events: {
          onStateChange: onPlayerStateChange,
        },
      });
    };

    $scope.vimeoPlayerSetup = function (iframe) {
      $scope.videoPlayer = new Vimeo.Player(iframe);
      $scope.videoPlayer.on('ended', () => {
        $scope.onVideoEnd();
      });
    };

    $scope.checkVideoSrc = function () {
      if ($scope.currentQuestion.video.type !== 'external') {
        $scope.videoSrc = 'uploaded';
      } else {
        const { url } = $scope.currentQuestion.video;
        const youtubeRegex = /^.*(youtube\.com\/embed\/).*/;
        const youtubeMatch = url.match(youtubeRegex);
        const vimeoRegex = /^.*(player\.vimeo\.com\/video\/).*/;
        const vimeoMatch = url.match(vimeoRegex);

        if (youtubeMatch) {
          $scope.videoSrc = 'youtube';
        } else if (vimeoMatch) {
          $scope.videoSrc = 'vimeo';
        } else {
          $scope.videoSrc = 'other';
        }
      }
    };

    $scope.videoSrcPostfix = function () {
      $scope.checkVideoSrc();

      if ($scope.videoSrc === 'youtube') {
        return '?enablejsapi=1';
      }
      return '';
    };

    $scope.pauseVideo = function () {
      $scope.checkVideoSrc();
      if ($scope.videoSrc === 'youtube' && $scope.videoPlayer) {
        $scope.videoPlayer.pauseVideo();
      } else if (($scope.videoSrc === 'vimeo' || $scope.videoSrc === 'uploaded') && $scope.videoPlayer) {
        $scope.videoPlayer.pause();
      } else {
        angular.element('iframe').attr('src', $scope.currentQuestion.video.url);
      }
    };

    // setup video player if there's a video

    if ($scope.currentQuestion.video.url) {
      $scope.canContinue = !$scope.currentQuestion.watch_video;
      if ($scope.videoPlayer) {
        return;
      }

      if ($scope.currentQuestion.video.type !== 'external') {
        $scope.videoSrc = 'uploaded';
      } else {
        const { url } = $scope.currentQuestion.video;
        const youtubeRegex = /^.*(youtube\.com\/embed\/).*/;
        const youtubeMatch = url.match(youtubeRegex);
        const vimeoRegex = /^.*(player\.vimeo\.com\/video\/).*/;
        const vimeoMatch = url.match(vimeoRegex);

        if (youtubeMatch) {
          $scope.videoSrc = 'youtube';
        } else if (vimeoMatch) {
          $scope.videoSrc = 'vimeo';
        } else {
          $scope.videoSrc = 'other';
        }
      }

      $timeout(() => {
        if ($scope.videoSrc === 'uploaded') {
          // eslint-disable-next-line prefer-destructuring
          $scope.videoPlayer = angular.element('video')[0];
          $scope.videoPlayer.onended = $scope.onVideoEnd;
        } else {
          const iframe = angular.element('iframe')[0];
          if ($scope.videoSrc === 'youtube') {
            $scope.youtubePlayerSetup(iframe);
          } else if ($scope.videoSrc === 'vimeo') {
            $scope.vimeoPlayerSetup(iframe);
          } else {
            $scope.canContinue = true;
          }
        }
      }, 1000);
    }

    $scope.submitAnswer = function (timedOut) {
      $scope.stopQuestionAudio($scope.currentQuestion.question_id);
      $scope.$broadcast('timer-stop');

      if (angular.isUndefined(timedOut)) {
        timedOut = false;
      }

      $scope.questionVariables.timedOut = timedOut;

      if (!timedOut) {
        $scope.analyticsService.sendEvent({
          category: 'player action',
          action: 'button clicked',
          label: 'interstitialContinue',
        });
      }

      $scope.gameData.nextCardId = $scope.currentQuestion.next_question_id_correct;
      $scope.questionVariables.questionCorrect = false;
      $scope.questionVariables.questionAnswered = true;
      $scope.pauseVideo();
      $scope.$emit('questionAnswered');
      $scope.$emit('showFeedbackResults', {
        data: $scope.currentQuestion,
        questionVariables: $scope.questionVariables,
      });
    };

    $scope.$on('countdown-complete', () => {
      $scope.submitAnswer(true);
    });
  },
]);
